module.exports = __webpack_public_path__ + "static/media/logout.d5702c40.svg";